/*
SimpleYouTubePlayer
by John E Maddox
*/

$(document).ready(function(){
    console.log('loading youtube player');
  // display video player
  $('.video-header A').on('click',function(e){

    e.preventDefault();

    // get video url
    var u = $(this).attr('href');

    // display video
    var width = $(window).width();
    var widthAndHeight = width > 800 ? 'width="784" height="441"' : 'onload="this.width=' + (width - 20)  + ';this.height=' + (width - 20)/1.77 + ';"';
      // get video id
    var i = u.substring(u.search('=')+1,u.length);

    // build player
    $('#mPlayer DIV').html('<iframe ' + widthAndHeight + ' src="https://www.youtube.com/embed/' + i + '" frameborder="0" allowfullscreen></iframe>');

    // display player
    $('#mPlayer').fadeIn(500);
  }); // eof display player

  // hide video player
  $('#mPlayer').on('click',function(e){

    // hide player
    $('#mPlayer').fadeOut(500);

    // destroy player
    $('#mPlayer DIV').empty();

  }); // eof hide player
});
